// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1FnRz","footer":"Form_footer__cEyAe"};